import _ from "lodash";
import defaultAppConfig from "../defaultAppConfig.json";
import defaultSummaryConfig from "../defaultSummaryConfig.json";
import client, { configuration } from "../api/client/SdsWebApiClient";
import { SummaryConfig, Convert } from "../models/summaryConfig";
import { SdsAccountInfo } from "../api/generated";

const getAppConfig = async (path: string | undefined | null = null): Promise<any> => {
    if (!path) return defaultAppConfig;
    const response = await fetch(path, { cache: "no-cache" });
    const config = await response.json();
    const mergeConfigs = _.merge(defaultAppConfig, config);
    return mergeConfigs;
};

const getSummaryData = async (path: string | undefined | null = null): Promise<SummaryConfig> => {
    if (!path) return Convert.toSummaryConfig(JSON.stringify(defaultSummaryConfig));
    const response = await fetch(path, { cache: "no-cache" });
    const config = await response.json();

    return Convert.toSummaryConfig(JSON.stringify(config || defaultSummaryConfig));
};

export const loadConfigurationFiles = async (
    language: string,
    account?: string | null
): Promise<[Object, SummaryConfig]> => {
    const configurationFilesUrls = await client.getConfigurationFilesGet(language, account || undefined);
    return Promise.all([
        getAppConfig(configurationFilesUrls.stylingFile),
        getSummaryData(configurationFilesUrls.summaryFile),
    ]);
};

export const getFrontendSettings = async () => {
    const response = await fetch(`${configuration.basePath}/frontend_settings.json`, { cache: "no-cache" });
    const settings = await response.json();
    return settings;
};

export const getAppVersion = async () => {
    const response = await fetch("./appversion.txt", { cache: "no-cache" });
    if (response.ok) {
        const appVersion = (await response.text()).trim();
        if (/^\d+(\.\d+)*$/.test(appVersion)) {
            return appVersion;
        }
    }
    return "Development";
};

export const loadAppCustomization = async (account: SdsAccountInfo) => {
    const response = await fetch(`${account.publicContentDir}/customization.json`, { cache: "no-cache" });
    return response.json();
};

export const getModelFromConfig = (config: string) => {
    // Assuming the config is always in either classic or swift "default" encoding,
    // with the model at the start of the string.
    const firstDot = config.indexOf(".");
    const firstSemicolon = config.indexOf(";");
    let modelEndIndex;
    if (firstDot !== -1 && firstSemicolon !== -1) {
        modelEndIndex = Math.min(firstDot, firstSemicolon);
    } else if (firstDot !== -1) {
        modelEndIndex = firstDot;
    } else {
        modelEndIndex = firstSemicolon;
    }
    return modelEndIndex === -1 ? config : config.substring(0, modelEndIndex);
};
